<template>
  <b-row>
    <b-col cols="8">
      <step :ComponentName="'GCCReceived'" ref="formData" />
    </b-col>
    <b-col cols="4">
      <GccDetail :gccObj="gccDetail"> </GccDetail>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import step from "../forms/step.vue";
import GccDetail from "./components/GCCDetail.vue";

import * as gccStore from "@/store/api/gcc/index.js";

export default {
  components: {
    BRow,
    BCol,
    step,
    GccDetail,
  },
  data() {
    return {
      gccDetail: {
        rootobject: {},
      },
    };
  },
  mounted() {
    this.getGccApi();
  },
  methods: {
    getGccApi() {
      const _this = this;
      gccStore
        .getApiById(this.$route.query.id)
        .then((response) => {
          _this.$refs.formData.$data.company.complaintDetail =
            "(" +
            response.data.data.rootobject.case_code +
            ") - " +
            response.data.data.rootobject.detail;
          _this.$refs.formData.$data.deptComplaintCode =
            response.data.data.rootobject.case_id;
          _this.gccDetail = response.data.data;
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
